import type { IssueViewRealtimeEventType } from '@atlassian/jira-issue-shared-types';
import { ISSUE_UPDATED_EVENT, ISSUE_COMMENTED_EVENT } from '@atlassian/jira-realtime';

export const EVENTS_TO_LISTEN: IssueViewRealtimeEventType[] = [
	ISSUE_UPDATED_EVENT,
	ISSUE_COMMENTED_EVENT,
];

export const REALTIME_EVENTS_ANALYTICS_SAMPLE_RATE = 100;
